export const state = () => ({
})

export const getters = {
  
}

export const mutations = {
 
}

export const actions = {
  async encodeHeader({dispatch},taxid) {
      const response = await this.$axios.get('https://service-etax.one.th/etaxdatetime/init')
      const tokenSet = response.data.message + "_" + taxid
      const encodeBaase64 = window.btoa(tokenSet)
      const randomStr1 =  await dispatch('random',50)
      const randomStr2 =  await dispatch('random',35)
      const srtEndcod = randomStr1+encodeBaase64+randomStr2
      return srtEndcod
  },
  async encodeBody({dispatch},body) {
      const payloadJson = JSON.stringify(body);
      const encodeBaase64 =  btoa(encodeURIComponent(payloadJson).replace(/%([0-9A-F]{2})/g,
          function toSolidBytes(match, p1) {
              return String.fromCharCode('0x' + p1);
      }))
      const randomStr1 =  await dispatch('random',50)
      console.log(randomStr1,"randomStr1");
      const randomStr2 =  await dispatch('random',35)
      const srtEndcod = randomStr1+encodeBaase64+randomStr2
      return srtEndcod
  },
  random({ state },len) {
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;
      let counter = 0;
      while (counter < len) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
      }
      return result
  }
}
